import { HelpOutline } from "@mui/icons-material";
import { Button as MuiButton, Tooltip as MuiTooltip } from "@mui/material";
import React, { ReactElement, useState } from "react";

export interface TooltipProps {
  label: string;
  children: string | ReactElement;
}

const buttonStyles = {
  textDecoration: "underline",
  padding: "0 5px",
  whiteSpace: "nowrap",
};

export const Tooltip: React.FC<TooltipProps> = ({ label, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MuiTooltip
      open={isOpen}
      onOpen={() => {
        setIsOpen(true);
      }}
      onClose={() => {
        setIsOpen(false);
      }}
      describeChild
      title={children}
      enterDelay={500}
      leaveDelay={200}
      placement="top-end"
    >
      <MuiButton
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        color="primary"
        variant="text"
        size="small"
        startIcon={<HelpOutline />}
        sx={buttonStyles}
      >
        {label}
      </MuiButton>
    </MuiTooltip>
  );
};
